import DatePickerPeriodPure from 'components/DatePickerPeriod/DatePickerPeriodPure';
import GroupButtons from 'components/GroupButtons';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { CALENDAR_PICKER_TYPE } from 'features/settingStaff/services/constants';
import { isArray } from 'lodash';
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import styled from 'styled-components';

type DateControlInputProps = {
  value?: {
    startDate: string;
    endDate: string;
    viewType: CALENDAR_PICKER_TYPE;
  };
  onChange?: (value: {
    startDate: string;
    endDate: string;
    viewType: CALENDAR_PICKER_TYPE;
  }) => void;
};

const options = [
  {
    label: 'Daily',
    value: CALENDAR_PICKER_TYPE.DATE,
  },
  {
    label: 'Weekly',
    value: CALENDAR_PICKER_TYPE.WEEK,
  },
  {
    label: 'Monthly',
    value: CALENDAR_PICKER_TYPE.MONTH,
  },
];

const DateControlInput = ({
  value = {
    startDate: moment().format(DATE_FORMAT),
    endDate: moment().format(DATE_FORMAT),
    viewType: CALENDAR_PICKER_TYPE.DATE,
  },
  onChange,
}: DateControlInputProps) => {

  const convertDateByViewType = (viewType: CALENDAR_PICKER_TYPE, date?: Moment | null) => {
    const dateConvert = date ? moment(date) : moment();
    switch (viewType) {
      case CALENDAR_PICKER_TYPE.MONTH:
        return {
          startDate: dateConvert.startOf('month').format(DATE_FORMAT),
          endDate: dateConvert.endOf('month').format(DATE_FORMAT),
        };
      case CALENDAR_PICKER_TYPE.WEEK:
        return {
          startDate: dateConvert.startOf('week').format(DATE_FORMAT),
          endDate: dateConvert.endOf('week').format(DATE_FORMAT),
        };
      case CALENDAR_PICKER_TYPE.DATE:
      default:
        return {
          startDate: dateConvert.format(DATE_FORMAT),
          endDate: dateConvert.format(DATE_FORMAT),
        };
    }
  };

  const handleChangeTypeView = (type: string) => {
    const { startDate, endDate } = convertDateByViewType(type as CALENDAR_PICKER_TYPE);
    onChange?.({
      viewType: type as CALENDAR_PICKER_TYPE,
      startDate: startDate,
      endDate: endDate,
    });
  };

  const handleChangeDate = (date: Moment | RangeValue<Moment>) => {
    if (isArray(date)) {
      const startDate = moment(date?.[0]).format(DATE_FORMAT);
      const endDate = moment(date?.[1]).format(DATE_FORMAT);
      onChange?.({ viewType: value.viewType, startDate, endDate });
    } else {
      const { startDate, endDate } = convertDateByViewType(value.viewType, date);
      onChange?.({ ...value, startDate: startDate, endDate: endDate });
    }
  };

  return (
    <Container>
      <GroupButtons v2 options={options} onChange={handleChangeTypeView} value={value?.viewType} />
      <DatePickerPeriodPure
        v2
        onChange={handleChangeDate}
        picker={value?.viewType}
        data={{ startDate: value?.startDate, endDate: value?.endDate }}
      />
    </Container>
  );
};

export default DateControlInput;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
